import React from 'react';
import { iconStyle } from './../common/styles';
import { lazyLoad } from '@react-page/editor';
var ImageIcon = lazyLoad(function () { return import('@mui/icons-material/Landscape'); });
var ImageHtmlRenderer = function (props) {
    var data = props.data;
    var src = data === null || data === void 0 ? void 0 : data.src;
    var alt = (data === null || data === void 0 ? void 0 : data.alt) ? data === null || data === void 0 ? void 0 : data.alt : "";
    var width = data === null || data === void 0 ? void 0 : data.width;
    var height = data === null || data === void 0 ? void 0 : data.height;
    var pub_src = data === null || data === void 0 ? void 0 : data.pub_src;
    var use_public_storage = props.useStorageUrl ? props.useStorageUrl : false;
    var openInNewWindow = data === null || data === void 0 ? void 0 : data.openInNewWindow;
    var alignment = (data === null || data === void 0 ? void 0 : data.alignment) ? data === null || data === void 0 ? void 0 : data.alignment : 'center';
    var verticalAlignment = (data === null || data === void 0 ? void 0 : data.verticalAlignment) ? data === null || data === void 0 ? void 0 : data.verticalAlignment : 'center';
    var image = (pub_src && use_public_storage) ? (React.createElement("img", { alt: alt, src: pub_src, width: width, height: height })) : (React.createElement("img", { alt: alt, src: src, width: width, height: height }));
    return src ? (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: verticalAlignment,
        } },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                justifyContent: alignment,
            } }, (data === null || data === void 0 ? void 0 : data.href) ? (React.createElement("a", { onClick: props.isEditMode ? function (e) { return e.preventDefault(); } : undefined, href: data === null || data === void 0 ? void 0 : data.href, target: openInNewWindow ? '_blank' : undefined, rel: openInNewWindow ? 'noreferrer noopener' : undefined }, image)) : (image)))) : (React.createElement("div", null,
        React.createElement("div", { className: "react-page-plugins-content-image-placeholder" },
            React.createElement(ImageIcon, { style: iconStyle }))));
};
export default ImageHtmlRenderer;
//# sourceMappingURL=ImageHtmlRenderer.js.map